<template>
  <div>
    <form @submit.prevent="submit">
      <div class="pl-2 pr-4 py-4">
        <div class="columns is-mobile is-variable is-1 is-vcentered">
          <div class="column is-narrow">
            <b-tooltip label="Kembali" type="is-dark">
              <button
                type="button"
                class="button is-white"
                @click="$router.go(-1)"
              >
                <b-icon icon="arrow-left"></b-icon>
              </button>
            </b-tooltip>
          </div>
          <div class="column">
            <h1 class="title is-5 has-text-weight-medium">
              Ubah
            </h1>
          </div>
          <div class="column is-narrow has-text-right">
            <b-button
              native-type="submit"
              type="is-primary"
              icon-left="check-bold"
            >
              Simpan
            </b-button>
          </div>
        </div>
      </div>

      <div class="p-4" style="max-width: 500px">
        <b-notification
          type="is-danger"
          aria-close-label="Tutup"
          role="alert"
          v-if="error"
          :closable="false"
        >
          {{ error | capitalize }}
        </b-notification>

        <b-field grouped>
          <template #label>
            Kontak Bantuan (Whatsapp) *
            <b-tooltip
              multilined
              type="is-dark"
              label="Akan digunakan pada halaman login aplikasi mobile"
            >
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <b-field>
            <b-input
              v-model="whatsappNumber"
              placeholder="6281234567890"
            ></b-input>
          </b-field>

          <p class="control">
            <b-button
              tag="a"
              :href="`https://wa.me/${whatsappNumber}`"
              target="_blank"
              icon-pack="mdi"
              icon-right="chevron-right"
              type="is-primary"
              :disabled="!whatsappNumber"
            >
              Buka
            </b-button>
          </p>
        </b-field>

        <br />

        <small>
          <i><span class="mr-2">*</span> : Wajib diisi</i>
        </small>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "SettingForm",
  data() {
    return {
      error: "",
      isWfh: false,
      whatsappNumber: "",
      maxDistance: "",
      checkInTolerance: "",
      checkOutTolerance: ""
    };
  },
  methods: {
    loadSetting() {
      const loadingComponent = this.$buefy.loading.open();

      this.$http({
        url: "settings",
        method: "GET",
        headers: {
          Authorization: null
        }
      })
        .then(res => {
          const data = res.data.data;

          this.isWfh = !data.is_wfo;
          this.whatsappNumber = data.contact_phone_number;
          this.maxDistance = data.wfo_max_distance;
          this.checkInTolerance = data.check_in_tolerance;
          this.checkOutTolerance = data.check_out_tolerance;

          loadingComponent.close();
        })
        .catch(() => {
          loadingComponent.close();

          this.$buefy.snackbar.open({
            message: "Gagal memuat Pengaturan",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => {
              this.loadSetting();
            }
          });
        });
    },
    submit() {
      this.error = "";
      const loadingComponent = this.$buefy.loading.open();

      this.$http({
        url: "settings",
        method: "PUT",
        data: {
          is_wfo: !this.isWfh,
          contact_phone_number: this.whatsappNumber,
          wfo_max_distance: this.maxDistance,
          check_in_tolerance: this.checkInTolerance,
          check_out_tolerance: this.checkOutTolerance
        }
      })
        .then(() => {
          this.$buefy.toast.open({
            message: `Berhasil mengubah Pengaturan <i class="mdi mdi-check-bold has-text-success"></i>`
          });

          loadingComponent.close();
        })
        .catch(error => {
          loadingComponent.close();

          if (error.response.status === 400) {
            const errors = error.response.data.errors;
            this.error = errors[Object.keys(errors)[0]][0];
            return;
          }

          this.$buefy.snackbar.open({
            message: `Gagal mengubah Pengaturan`,
            type: "is-warning",
            duration: 5000,
            actionText: "Retry",
            onAction: () => {
              this.submit();
            }
          });
        });
    }
  },
  created() {
    this.loadSetting();
  },
  computed: {
    maxDistanceKm: {
      get() {
        return this.maxDistance / 1000;
      },
      set(value) {
        this.maxDistance = value * 1000;
      }
    }
  }
};
</script>
